import * as React from "react";
import { Modal, Button, Icon } from "antd";
import "./ExceedMaxPriceBalanceModalView.scss";
import { ExceedMaxPriceBalanceModalView } from './ExceedMaxPriceBalanceModalView';
import { useContext } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ShowNotification } from "../../ShowNotification/ShowNotification";
import { IExceedMaxPriceBalance } from "src/services/interfaces/IExceedMaxPriceBalance";

interface IViewExceedMaxPriceBalanceButtonProps {
  id: number;
}
export const ViewExceedMaxPriceBalanceButton: React.FC<IViewExceedMaxPriceBalanceButtonProps> = ({ id }) => {

  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [balance, setBalance] = React.useState<IExceedMaxPriceBalance>(null);
  const { exceedMaxPriceBalanceService } = useContext(ServiceContext);

  React.useEffect(() => {
    if (id && id !== 0) {
      fetch(id);
    }
  }, [id]);

  function fetch(balanceId: number) {
    exceedMaxPriceBalanceService
      .getById(balanceId)
      .then(setBalance)
      .catch(() => ShowNotification.Error("Falha!", "Falha ao buscar o extrato, tente novamente"));
  }

  return (
    <>
      <Button
        className="view-fraud btn"
        disabled={!balance}
        onClick={() => {
          setShowModal(true);
        }}
        style={{ marginLeft: "30px" }}>
        <Icon type="add" />
        Visualizar histórico de utilização
      </Button>
      <Modal className="prefraud-modal" title={"Extrato e utilização do saldo de gordura"} visible={showModal} onOk={() => setShowModal(false)} onCancel={() => setShowModal(false)}>
        <ExceedMaxPriceBalanceModalView balance={balance} />
      </Modal>
    </>
  );
}

export default ViewExceedMaxPriceBalanceButton;



// WEBPACK FOOTER //
// ./src/components/common/CommissionView/ExceedMaxPriceBalance/ViewExceedMaxPriceBalanceButton.tsx